module.exports = __webpack_public_path__ + "static/media/3.9d08ae74.jpg";